export enum StoreName {
  WEGMANS = "wegmans",
  COSTCO = "costco",
}
